<template>
  <div class="page-container">
    <div style="width: 900px; margin: 0 auto">
      <div style="text-align: center; margin-bottom: 50px; padding-top: 100px">
        <span style="font-size: 25px">{{$t('changeAccount.changeAccount35')}}</span>
      </div>
      <el-steps :active="active" finish-status="success">
        <el-step :title="$t('loginR.login23')"></el-step>
        <el-step :title="$t('changeAccount.changeAccount5')"></el-step>
        <el-step :title="$t('changeAccount.changeAccount12')"></el-step>
      </el-steps>
      <div class="block">
        <el-carousel
          style="margin-top: 100px"
          indicator-position="none"
          arrow="never"
          :autoplay="false"
          :loop="false"
          ref="carousel"
        >
          <el-carousel-item name="check">
            <div>
              <div style="display: flex;justify-content: center;">
                <span style="font-size: 16px;">
                  {{$t('changeAccount.changeAccount3')}}：{{ showEmail }}
                </span>
              </div>
              <div style="margin-left: 248px">
                <el-input
                  :placeholder="$t('changeAccount.changeAccount13')"
                  v-model="verifyCode"
                  style="width: 300px; margin-top: 25px;"
                  @blur="checkVerityCode"
                  @focus="clearTip"
                >
                </el-input>
                <el-button
                  style="width: 135px; height: 50px; padding: 12px 10px"
                  type="info"
                  @click="sendCode(0)"
                  :disabled="disabled"
                  >{{ sendBtnText }}</el-button
                >
                <div
                  style="display: inline-block"
                  v-if="tipActive"
                >
                  <img
                    src="../../assets/images/setting/error.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                    v-if="!res"
                  />
                  <img
                    src="../../assets/images/setting/p0.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                    v-if="res"
                  />
                  <span style="color: red; font-size: 15px" v-if="!res">{{
                    tip
                  }}</span>
                  <span style="color: green; font-size: 15px" v-if="res">{{
                    tip
                  }}</span>
                </div>
              </div>
            </div>
            <el-button
              @click="next"
              type="info"
              style="
                width: 300px;
                height: 50px;
                margin-left: 300px !important;
                margin-top: 25px;
              "
              >{{$t('changeAccount.changeAccount17')}}</el-button
            >
          </el-carousel-item>
          <el-carousel-item name="set">
            <div>
              <div>
                <el-input
                  :placeholder="$t('changeAccount.changeAccount38')"
                  v-model="newEmail"
                  style="width: 420px; margin-left: 250px"
                  @blur="checkEmail"
                  @focus="clearTip"
                >
                </el-input>
              </div>
              <div>
                <el-input
                  :placeholder="$t('changeAccount.changeAccount13')"
                  v-model="verifyCode"
                  style="width: 260px; margin-left: 250px; margin-top: 25px"
                  @blur="checkVerityCode"
                  @focus="clearTip"
                >
                </el-input>
                <el-button
                  style="width: 162px; height: 50px;padding: 12px 10px;"
                  type="info"
                  @click="sendCode(1)"
                  :disabled="disabled"
                  >{{ sendBtnText }}</el-button
                >
                <div
                  style="display: inline-block;display:flex;justify-content: center;"
                  v-if="tipActive"
                >
                  <img
                    src="../../assets/images/setting/error.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                    v-if="!res"
                  />
                  <img
                    src="../../assets/images/setting/p0.png"
                    alt=""
                    style="float: left; margin-left: 20px"
                    v-if="res"
                  />
                  <span style="color: red; font-size: 15px" v-if="!res">{{
                    tip
                  }}</span>
                  <span style="color: green; font-size: 15px" v-if="res">{{
                    tip
                  }}</span>
                </div>
              </div>
            </div>
            <el-button
              @click="next"
              type="info"
              style="
                width: 300px;
                height: 50px;
                margin-left: 300px !important;
                margin-top: 25px;
              "
              >{{$t('loginR.login26')}}</el-button
            >
          </el-carousel-item>
          <el-carousel-item name="complete">
            <div style="text-align: center">
              <img src="../../assets/images/setting/u534.png" alt="" />
            </div>
            <div style="text-align: center; margin-top: 15px">
              <span style="font-size: 20px">{{$t('changeAccount.changeAccount39')}}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div style="background-color: rgba(249, 249, 249, 1); padding: 20px">
          <div style="margin-bottom: 10px">
            <span style="color: #999999; font-size: 16px">{{$t('changeAccount.changeAccount40')}}</span>
          </div>
          <div style="margin-bottom: 5px">
            <span style="color: #999999"
              >• {{$t('changeAccount.changeAccount41')}}</span
            >
          </div>
          <div>
            <span style="color: #999999"
              >• {{$t('changeAccount.changeAccount42')}}400-1688-168（9:00-22:00）</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.el-input__inner {
  height: 50px;
  font-size: 16px;
}
</style>
<script>
export default {
  data() {
    return {
      showEmail: "",
      password: "",
      rePassword: "",
      res: false,
      sendBtnText: this.$t('changeAccount.changeAccount14'),
      timeCount: 0,
      verifyCode: "",
      tip: "",
      tipActive: false,
      active: 0,
      disabled: false,
      timer: null,
      secretCode: "",
      secretCode2: "",
      emailAddress: "",
      newEmail: "",
    };
  },
  methods: {
    checkEmail() {
      if (!this.newEmail || !this.newEmail.trim(" ")) {
        this.tip = this.$t('login.login19');
        this.tipActive = true;
      } else {
        // const regMobile = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/;
        const regMobile = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (!regMobile.test(this.newEmail)) {
          this.tip = this.$t('login.login20');
          this.tipActive = true;
        } else {
          if (this.emailAddress == this.newEmail) {
            this.res = false;
            this.tip = this.$t('changeAccount.changeAccount43');
            this.tipActive = true;
          }
        }
      }
    },
    startTimer() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.timeCount = TIME_COUNT;
        this.disabled = true;
        this.timer = setInterval(() => {
          if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
            this.timeCount--;
            this.sendBtnText = this.timeCount + this.$t('changeAccount.changeAccount36')+this.$t('changeAccount.changeAccount37');
          } else {
            this.disabled = false;
            this.sendBtnText = this.$t('loginR.login31');
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    checkVerityCode() {
      if (!this.verifyCode || !this.verifyCode.trim(" ")) {
        this.res = false;
        this.tip = this.$t('login.login16');
        this.tipActive = true;
      } else {
        const regMobile = /^[0-9]{4}$/;
        if (!regMobile.test(this.verifyCode)) {
          this.res = false;
          this.tip = this.$t('login.login17');
          this.tipActive = true;
        }
      }
    },
    async sendCode(type) {
      var url = "admin/sendVerificationCode";
      let params = {};
      if (type == 0) {
        params = { smsType: 1 };
      } else if (type == 1) {
        this.tip = "";
        this.tipActive = false;
        this.checkEmail();
        if (!this.tipActive) {
          params = { smsType: 1, email: this.newEmail };
        }else{
          return "";
        }
      }
      let { data: res } = await this.$http.get(url, {
        params,
      });
      if (res.code == 200) {
        this.res = true;
        this.tip = this.$t('login.login18');
        this.tipActive = true;
        this.startTimer();
      } else {
        this.res = false;
        this.tip = res.message;
        this.tipActive = true;
      }
    },
    clearTip() {
      (this.tip = ""), (this.tipActive = false);
    },
    async next() {
      if (this.active == 0) {
        this.clearTip();
        this.checkVerityCode();
        if (!this.tipActive) {
          var url = "admin/verifyCode";
          const { data: res } = await this.$http.post(url, {
            code: this.verifyCode,
          });
          if (res.code == 200) {
            this.verifyCode = "";
            this.res = false;
            this.secretCode = res.data.secretCode;
            this.tipActive = false;
            this.tip = "";
            clearInterval(this.timer);
            this.timer = null;
            this.disabled = false;
            this.sendBtnText = this.$t('changeAccount.changeAccount44');
            this.active = 1;
            this.$refs.carousel.next();
          } else {
            this.res = false;
            this.tip = res.message;
            this.tipActive = true;
          }
        }
      } else if (this.active == 1) {
        this.checkVerityCode();
        if (!this.tipActive) {
          var url = "admin/verifyCode";
          const { data: res } = await this.$http.post(url, {
            email: this.newEmail,
            code: this.verifyCode,
          });
          if (res.code == 200) {
            this.secretCode2 = res.data.secretCode;

            const { data: res2 } = await this.$http.post("admin/modifyAccountBinding", {
              email: this.newEmail,
              secretCode: this.secretCode,
              secretCode2: this.secretCode2,
            });
            if (res2.code == 200) {
              this.res = false;
              this.tipActive = false;
              this.tip = "";
              clearInterval(this.timer);
              this.timer = null;
              this.active = 3;
              this.$refs.carousel.next();
            } else {
              this.res = false;
              this.tip = res2.message;
              this.tipActive = true;
            }
          } else {
            this.res = false;
            this.tip = res.message;
            this.tipActive = true;
          }
        }
      }
    },
    async getUserInfo() {
      const { data: res } = await this.$http.get("customer/getCustomerInfo");
      if (res.code == 200) {
        this.emailAddress = res.data.emailAddress;
        this.showEmail =res.data.emailAddress.substring(0, 3) +
                "****" +
                res.data.emailAddress.substring(res.data.emailAddress.indexOf("@"));
      } else {
        this.$message({
          message: res.message,
          type: "error",
        });
      }
    },
  },
  created() {
    this.getUserInfo();
  },
};
</script>
